const containsChinese = value => /[\u3400-\u9fff]/.test(String(value || ''));

const makeDistrict = (value, alternate = value) => {
  const labels = containsChinese(value)
    ? { zh: value, en: alternate }
    : { zh: alternate, en: value };

  return {
    value,
    label: labels,
  };
};

const makeCity = (value, zh, districtValues) => ({
  value,
  label: { zh, en: value },
  districts: districtValues.map(item => (
    Array.isArray(item) ? makeDistrict(item[0], item[1]) : makeDistrict(item)
  )),
});

const makeCountry = (value, zh, cities) => ({
  value,
  label: { zh, en: value },
  cities,
});

export const LOCATION_TREE = [
  makeCountry('中国', '中国', [
    makeCity('北京', '北京', [
      ['东城区', 'Dongcheng District'], ['西城区', 'Xicheng District'],
      ['朝阳区', 'Chaoyang District'], ['海淀区', 'Haidian District'],
      ['丰台区', 'Fengtai District'], ['通州区', 'Tongzhou District'],
    ]),
    makeCity('上海', '上海', [
      ['黄浦区', 'Huangpu District'], ['徐汇区', 'Xuhui District'],
      ['静安区', 'Jing’an District'], ['长宁区', 'Changning District'],
      ['浦东新区', 'Pudong New Area'], ['闵行区', 'Minhang District'],
      ['宝山区', 'Baoshan District'],
    ]),
    makeCity('广州', '广州', [
      ['越秀区', 'Yuexiu District'], ['海珠区', 'Haizhu District'],
      ['荔湾区', 'Liwan District'], ['天河区', 'Tianhe District'],
      ['白云区', 'Baiyun District'], ['番禺区', 'Panyu District'],
      ['黄埔区', 'Huangpu District'],
    ]),
    makeCity('深圳', '深圳', [
      ['福田区', 'Futian District'], ['罗湖区', 'Luohu District'],
      ['南山区', 'Nanshan District'], ['宝安区', 'Bao’an District'],
      ['龙岗区', 'Longgang District'], ['龙华区', 'Longhua District'],
      ['盐田区', 'Yantian District'],
    ]),
    makeCity('杭州', '杭州', [
      ['西湖区', 'Xihu District'], ['滨江区', 'Binjiang District'],
      ['上城区', 'Shangcheng District'], ['拱墅区', 'Gongshu District'],
      ['余杭区', 'Yuhang District'], ['萧山区', 'Xiaoshan District'],
    ]),
    makeCity('成都', '成都', [
      ['锦江区', 'Jinjiang District'], ['青羊区', 'Qingyang District'],
      ['武侯区', 'Wuhou District'], ['成华区', 'Chenghua District'],
      ['金牛区', 'Jinniu District'], ['高新区', 'High-tech Zone'],
    ]),
    makeCity('重庆', '重庆', [
      ['渝中区', 'Yuzhong District'], ['江北区', 'Jiangbei District'],
      ['南岸区', 'Nan’an District'], ['沙坪坝区', 'Shapingba District'],
      ['九龙坡区', 'Jiulongpo District'], ['渝北区', 'Yubei District'],
    ]),
    makeCity('南京', '南京', [
      ['玄武区', 'Xuanwu District'], ['秦淮区', 'Qinhuai District'],
      ['鼓楼区', 'Gulou District'], ['建邺区', 'Jianye District'],
      ['栖霞区', 'Qixia District'], ['江宁区', 'Jiangning District'],
    ]),
    makeCity('武汉', '武汉', [
      ['江岸区', 'Jiangan District'], ['江汉区', 'Jianghan District'],
      ['硚口区', 'Qiaokou District'], ['武昌区', 'Wuchang District'],
      ['洪山区', 'Hongshan District'], ['东西湖区', 'Dongxihu District'],
    ]),
    makeCity('西安', '西安', [
      ['新城区', 'Xincheng District'], ['碑林区', 'Beilin District'],
      ['莲湖区', 'Lianhu District'], ['雁塔区', 'Yanta District'],
      ['未央区', 'Weiyang District'], ['长安区', 'Chang’an District'],
    ]),
    makeCity('苏州', '苏州', [
      ['姑苏区', 'Gusu District'], ['虎丘区', 'Huqiu District'],
      ['吴中区', 'Wuzhong District'], ['相城区', 'Xiangcheng District'],
      ['吴江区', 'Wujiang District'], ['工业园区', 'Suzhou Industrial Park'],
    ]),
    makeCity('天津', '天津', [
      ['和平区', 'Heping District'], ['南开区', 'Nankai District'],
      ['河西区', 'Hexi District'], ['河东区', 'Hedong District'],
      ['河北区', 'Hebei District'], ['滨海新区', 'Binhai New Area'],
    ]),
    makeCity('香港', '香港', [
      ['中西区', 'Central and Western District'], ['湾仔区', 'Wan Chai District'],
      ['九龙城区', 'Kowloon City District'], ['沙田区', 'Sha Tin District'],
      ['油尖旺区', 'Yau Tsim Mong District'], ['东区', 'Eastern District'],
    ]),
  ]),
  makeCountry('United States', '美国', [
    makeCity('New York', '纽约', [
      ['Manhattan', '曼哈顿'], ['Brooklyn', '布鲁克林'], ['Queens', '皇后区'],
      ['Bronx', '布朗克斯'], ['Staten Island', '史泰登岛'],
    ]),
    makeCity('Los Angeles', '洛杉矶', [
      ['Downtown LA', '洛杉矶市中心'], ['Hollywood', '好莱坞'],
      ['Westside', '西区'], ['San Fernando Valley', '圣费尔南多谷'],
    ]),
    makeCity('San Francisco', '旧金山', [
      ['Downtown', '市中心'], ['SOMA', '南市场区'], ['Mission', '教会区'],
      ['Sunset', '日落区'], ['Richmond', '里士满区'],
    ]),
    makeCity('Seattle', '西雅图', [
      ['Downtown', '市中心'], ['Capitol Hill', '国会山'],
      ['South Lake Union', '南湖联盟区'], ['Ballard', '巴拉德'],
      ['Queen Anne', '皇后安妮'],
    ]),
    makeCity('Chicago', '芝加哥', [
      ['The Loop', '市中心环区'], ['River North', '河北区'],
      ['Lakeview', '湖景区'], ['Lincoln Park', '林肯公园'],
      ['Hyde Park', '海德公园'],
    ]),
    makeCity('Boston', '波士顿', [
      ['Downtown', '市中心'], ['Back Bay', '后湾'], ['Fenway', '芬威'],
      ['Cambridge', '剑桥'], ['Somerville', '萨默维尔'],
    ]),
    makeCity('Austin', '奥斯汀', [
      ['Downtown', '市中心'], ['East Austin', '东奥斯汀'],
      ['South Congress', '南国会区'], ['North Austin', '北奥斯汀'],
    ]),
    makeCity('Washington, D.C.', '华盛顿特区', [
      ['Downtown', '市中心'], ['Capitol Hill', '国会山'],
      ['Georgetown', '乔治城'], ['Dupont Circle', '杜邦环岛'],
    ]),
    makeCity('Miami', '迈阿密', [
      ['Downtown', '市中心'], ['Brickell', '布里克尔'],
      ['Miami Beach', '迈阿密海滩'], ['Wynwood', '温伍德'],
    ]),
    makeCity('San Diego', '圣地亚哥', [
      ['Downtown', '市中心'], ['La Jolla', '拉霍亚'],
      ['Mission Valley', '米慎谷'], ['North Park', '北公园'],
    ]),
  ]),
  makeCountry('Canada', '加拿大', [
    makeCity('Toronto', '多伦多', [
      ['Downtown', '市中心'], ['North York', '北约克'],
      ['Scarborough', '士嘉堡'], ['Etobicoke', '怡陶碧谷'], ['York', '约克区'],
    ]),
    makeCity('Vancouver', '温哥华', [
      ['Downtown', '市中心'], ['Kitsilano', '基斯兰奴'],
      ['Richmond', '列治文'], ['Burnaby', '本拿比'], ['North Vancouver', '北温哥华'],
    ]),
    makeCity('Montreal', '蒙特利尔', [
      ['Ville-Marie', '维尔玛丽'], ['Plateau-Mont-Royal', '皇家山高原'],
      ['Rosemont', '罗斯蒙特'], ['Westmount', '西山'],
    ]),
  ]),
  makeCountry('United Kingdom', '英国', [
    makeCity('London', '伦敦', [
      ['City of London', '伦敦金融城'], ['Westminster', '威斯敏斯特'],
      ['Camden', '卡姆登'], ['Southwark', '萨瑟克'], ['Hackney', '哈克尼'],
    ]),
    makeCity('Manchester', '曼彻斯特', [
      ['City Centre', '市中心'], ['Salford', '索尔福德'],
      ['Didsbury', '迪兹伯里'], ['Ancoats', '安科茨'],
    ]),
    makeCity('Birmingham', '伯明翰', [
      ['City Centre', '市中心'], ['Edgbaston', '埃德巴斯顿'],
      ['Jewellery Quarter', '珠宝区'], ['Digbeth', '迪格贝斯'],
    ]),
    makeCity('Edinburgh', '爱丁堡', [
      ['Old Town', '老城'], ['New Town', '新城'],
      ['Leith', '利斯'], ['Stockbridge', '斯托克布里奇'],
    ]),
  ]),
  makeCountry('Australia', '澳大利亚', [
    makeCity('Sydney', '悉尼', [
      ['CBD', '中央商务区'], ['Surry Hills', '萨里山'],
      ['Parramatta', '帕拉马塔'], ['North Sydney', '北悉尼'], ['Bondi', '邦迪'],
    ]),
    makeCity('Melbourne', '墨尔本', [
      ['CBD', '中央商务区'], ['Southbank', '南岸'], ['Fitzroy', '菲茨罗伊'],
      ['Richmond', '里士满'], ['St Kilda', '圣基尔达'],
    ]),
    makeCity('Brisbane', '布里斯班', [
      ['CBD', '中央商务区'], ['South Brisbane', '南布里斯班'],
      ['Fortitude Valley', '毅力谷'], ['West End', '西区'],
    ]),
    makeCity('Perth', '珀斯', [
      ['CBD', '中央商务区'], ['Fremantle', '弗里曼特尔'],
      ['Subiaco', '苏比亚科'], ['East Perth', '东珀斯'],
    ]),
  ]),
  makeCountry('Japan', '日本', [
    makeCity('Tokyo', '东京', [
      ['Shinjuku', '新宿区'], ['Shibuya', '涩谷区'], ['Minato', '港区'],
      ['Chiyoda', '千代田区'], ['Taito', '台东区'],
    ]),
    makeCity('Osaka', '大阪', [
      ['Kita', '北区'], ['Chuo', '中央区'], ['Naniwa', '浪速区'],
      ['Tennoji', '天王寺区'], ['Nishinari', '西成区'],
    ]),
    makeCity('Kyoto', '京都', [
      ['Nakagyo', '中京区'], ['Shimogyo', '下京区'],
      ['Higashiyama', '东山区'], ['Sakyo', '左京区'],
    ]),
    makeCity('Nagoya', '名古屋', [
      ['Naka', '中区'], ['Higashi', '东区'], ['Nakamura', '中村区'], ['Chikusa', '千种区'],
    ]),
  ]),
  makeCountry('South Korea', '韩国', [
    makeCity('Seoul', '首尔', [
      ['Gangnam-gu', '江南区'], ['Jung-gu', '中区'], ['Mapo-gu', '麻浦区'],
      ['Yongsan-gu', '龙山区'], ['Songpa-gu', '松坡区'],
    ]),
    makeCity('Busan', '釜山', [
      ['Haeundae-gu', '海云台区'], ['Jung-gu', '中区'],
      ['Nam-gu', '南区'], ['Suyeong-gu', '水营区'],
    ]),
  ]),
  makeCountry('Singapore', '新加坡', [
    makeCity('Singapore', '新加坡', [
      ['Downtown', '市中心'], ['Orchard', '乌节路'],
      ['Marina Bay', '滨海湾'], ['Jurong East', '裕廊东'], ['Tampines', '淡滨尼'],
    ]),
  ]),
  makeCountry('Germany', '德国', [
    makeCity('Berlin', '柏林', [
      ['Mitte', '米特区'], ['Kreuzberg', '克罗伊茨贝格'],
      ['Prenzlauer Berg', '普伦茨劳贝格'], ['Charlottenburg', '夏洛滕堡'],
    ]),
    makeCity('Munich', '慕尼黑', [
      ['Altstadt-Lehel', '老城-莱赫尔'], ['Maxvorstadt', '马克斯沃施塔特'],
      ['Schwabing', '施瓦宾'], ['Haidhausen', '海德豪森'],
    ]),
    makeCity('Frankfurt', '法兰克福', [
      ['Innenstadt', '市中心'], ['Westend', '西区'],
      ['Sachsenhausen', '萨克森豪森'], ['Bornheim', '博恩海姆'],
    ]),
  ]),
  makeCountry('France', '法国', [
    makeCity('Paris', '巴黎', [
      ['Louvre', '卢浮宫区'], ['Le Marais', '玛黑区'],
      ['Latin Quarter', '拉丁区'], ['Montmartre', '蒙马特'], ['La Defense', '拉德芳斯'],
    ]),
    makeCity('Lyon', '里昂', [
      ['Presqu’ile', '半岛区'], ['Vieux Lyon', '里昂老城'],
      ['Part-Dieu', '帕尔迪厄'], ['La Croix-Rousse', '红十字山'],
    ]),
  ]),
  makeCountry('India', '印度', [
    makeCity('Bengaluru', '班加罗尔', [
      ['Central Bengaluru', '班加罗尔中心'], ['Whitefield', '怀特菲尔德'],
      ['Koramangala', '科拉曼加拉'], ['Indiranagar', '英迪拉纳加尔'],
    ]),
    makeCity('Mumbai', '孟买', [
      ['South Mumbai', '南孟买'], ['Bandra', '班德拉'],
      ['Andheri', '安泰里'], ['Powai', '波瓦伊'],
    ]),
    makeCity('New Delhi', '新德里', [
      ['Central Delhi', '德里中心'], ['South Delhi', '南德里'],
      ['Dwarka', '德瓦卡'], ['Rohini', '罗希尼'],
    ]),
    makeCity('Hyderabad', '海得拉巴', [
      ['HITEC City', '高科技城'], ['Banjara Hills', '班贾拉山'],
      ['Gachibowli', '加奇博利'], ['Secunderabad', '塞康德拉巴德'],
    ]),
  ]),
  makeCountry('United Arab Emirates', '阿联酋', [
    makeCity('Dubai', '迪拜', [
      ['Downtown Dubai', '迪拜市中心'], ['Dubai Marina', '迪拜码头'],
      ['Jumeirah', '朱美拉'], ['Business Bay', '商务湾'],
    ]),
    makeCity('Abu Dhabi', '阿布扎比', [
      ['Al Zahiyah', '阿尔扎希亚'], ['Al Reem Island', '里姆岛'],
      ['Khalifa City', '哈利法城'], ['Yas Island', '亚斯岛'],
    ]),
  ]),
  makeCountry('New Zealand', '新西兰', [
    makeCity('Auckland', '奥克兰', [
      ['Auckland CBD', '奥克兰市中心'], ['North Shore', '北岸'],
      ['Newmarket', '新市场'], ['Manukau', '马努考'],
    ]),
    makeCity('Wellington', '惠灵顿', [
      ['Te Aro', '蒂阿罗'], ['Cuba Street', '古巴街'],
      ['Thorndon', '索登'], ['Newtown', '新城'],
    ]),
  ]),
  makeCountry('Netherlands', '荷兰', [
    makeCity('Amsterdam', '阿姆斯特丹', [
      ['Centrum', '市中心'], ['De Pijp', '德派普'],
      ['Jordaan', '约旦区'], ['Amsterdam Noord', '阿姆斯特丹北区'],
    ]),
    makeCity('Rotterdam', '鹿特丹', [
      ['Centrum', '市中心'], ['Kop van Zuid', '南岸'],
      ['Kralingen', '克拉林根'], ['Delfshaven', '代尔夫斯哈芬'],
    ]),
  ]),
  makeCountry('Spain', '西班牙', [
    makeCity('Madrid', '马德里', [
      ['Centro', '中心区'], ['Salamanca', '萨拉曼卡'],
      ['Chamberi', '钱贝里'], ['Retiro', '丽池'],
    ]),
    makeCity('Barcelona', '巴塞罗那', [
      ['Ciutat Vella', '老城区'], ['Eixample', '扩展区'],
      ['Gracia', '格拉西亚'], ['Sants-Montjuic', '桑茨-蒙锥克'],
    ]),
  ]),
  makeCountry('Italy', '意大利', [
    makeCity('Milan', '米兰', [
      ['Centro Storico', '历史中心'], ['Brera', '布雷拉'],
      ['Navigli', '纳维利'], ['Porta Romana', '罗马门'],
    ]),
    makeCity('Rome', '罗马', [
      ['Centro Storico', '历史中心'], ['Trastevere', '特拉斯提弗列'],
      ['Prati', '普拉蒂'], ['Testaccio', '特斯塔乔'],
    ]),
  ]),
  makeCountry('Brazil', '巴西', [
    makeCity('Sao Paulo', '圣保罗', [
      ['Centro', '中心区'], ['Pinheiros', '皮涅鲁斯'],
      ['Vila Madalena', '马达莱纳村'], ['Itaim Bibi', '伊泰姆比比'],
    ]),
    makeCity('Rio de Janeiro', '里约热内卢', [
      ['Centro', '中心区'], ['Copacabana', '科帕卡巴纳'],
      ['Ipanema', '伊帕内玛'], ['Barra da Tijuca', '蒂茹卡巴拉'],
    ]),
  ]),
  makeCountry('Mexico', '墨西哥', [
    makeCity('Mexico City', '墨西哥城', [
      ['Cuauhtemoc', '夸乌特莫克'], ['Polanco', '波兰科'],
      ['Condesa', '孔德萨'], ['Coyoacan', '科约阿坎'],
    ]),
    makeCity('Monterrey', '蒙特雷', [
      ['Centro', '中心区'], ['San Pedro', '圣佩德罗'],
      ['Obispado', '主教区'], ['Cumbres', '昆布雷斯'],
    ]),
  ]),
  makeCountry('South Africa', '南非', [
    makeCity('Cape Town', '开普敦', [
      ['City Bowl', '城市碗'], ['Woodstock', '伍德斯托克'],
      ['Sea Point', '海点'], ['Camps Bay', '坎普斯湾'],
    ]),
    makeCity('Johannesburg', '约翰内斯堡', [
      ['Sandton', '桑顿'], ['Rosebank', '罗斯班克'],
      ['Melville', '梅尔维尔'], ['Soweto', '索韦托'],
    ]),
  ]),
];

export function splitLocation(value) {
  const parts = String(value || '').split(':');
  return [parts[0] || '', parts[1] || '', parts[2] || ''];
}

export function locationLabel(value, language = 'en') {
  if (!value) return language === 'zh' ? '全部位置' : 'All locations';
  const [country, cityValue, districtValue] = splitLocation(value);
  const countryItem = LOCATION_TREE.find(item => item.value === country);
  const cityItem = countryItem?.cities.find(item => item.value === cityValue);
  const districtItem = cityItem?.districts.find(item => item.value === districtValue);
  return [countryItem, cityItem, districtItem]
    .filter(Boolean)
    .map(item => item.label[language] || item.value)
    .join(' · ');
}
